<template>
   <div class="chart-desc">
      <!-- Header -->
      <h1 class="chart-desc__header">
         {{ chartTitle }}
         {{ isframeworkvisible && showFWNameInHeader ? `${'in ' + getname}` : '' }}
         <span v-if="product" class="badge badge-custom">Part of {{ product }}</span>
      </h1>

      <!-- Paragraph -->
      <div
         class="chart-desc__para"
         :class="{ 'chart-desc__para--expand': divExpand }"
         v-html="markedRender(chartDesc)"
      ></div>
      <span
         v-if="!isframeworkvisible && !divExpand"
         class="chart-desc__read-more"
         @click="expandingDiv"
      >
         Read More
      </span>

      <div class="chart-desc-ctas pt-2">
         <ChartButtons
            v-if="isframeworkvisible"
            :framework="framework"
            :get-started-ctas="getStartedCtas"
         />
      </div>
   </div>
</template>

<script>
import ChartButtons from './ChartButtons.vue';
import languages from '../playground/languages';

export default {
   name: 'ChartDesc',

   components: {
      ChartButtons,
   },

   props: {
      chartTitle: {
         type: String,
         required: true,
      },
      chartDesc: {
         type: String,
         default: '',
      },
      frameworkName: {
         type: String,
         default: 'js',
      },
      getStartedCtas: {
         type: Array,
         default: () => [],
      },
      textAddOn: {
         type: Boolean,
         default: false,
      },
      framework: {
         type: String,
         default: 'js',
      },
      isframeworkvisible: {
         type: Boolean,
         default: true,
      },
      product: {
         type: String,
         default: '',
      },
      showFWNameInHeader: {
         type: Boolean,
         default: true,
      },
   },

   data() {
      return {
         divExpand: this.isframeworkvisible || false,
      };
   },

   computed: {
      getname() {
         const [f] = languages.filter(({ value }) => value === this.framework);
         return typeof f !== 'undefined' ? f.name : languages[0].name;
      },
   },

   watch: {
      $route() {
         this.divExpand = this.isframeworkvisible || false;
      },
   },

   methods: {
      expandingDiv() {
         this.divExpand = !this.divExpand;
      },

      goTo(url) {
         const reload = this.$reloadType(url);
         if (!reload) {
            this.$router.push(url).catch(err => {});
         } else {
            window.open(url, '_blank');
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.chart-desc {
   &__header {
      line-height: 48px;
   }
   &__para {
      color: #4a4a4a;
      margin-bottom: 0.2rem;
      letter-spacing: 0.23px;
      overflow: hidden;
      max-height: 78px;
   }
   &__read-more {
      color: #8297a2;
      text-transform: uppercase;
      margin-bottom: 2rem;
      display: inline-block;
      cursor: pointer;
      &:hover,
      &:active {
         color: darken(#8297a2, 15%);
      }
   }
   &__para--expand {
      max-height: 1000px !important;
      transition: 0.8s max-height ease-in-out;
   }

   .badge-custom {
      border-radius: 2px;
      border: 1px solid rgba(62, 57, 107, 0.13);
      background-color: rgba(62, 57, 107, 0.04);
      color: #212344;
      font-weight: 600;
      letter-spacing: 0.2px;
      line-height: 15px;
      font-size: 12px;
      vertical-align: middle;
   }
   .chart-desc-ctas {
      .chart-btn {
         &--grad-custom,
         &--primary-custom {
            padding: 13px 24px;
            font-size: 15px;
            margin-right: 18px;
            line-height: 16px;
            &:hover {
               box-shadow: 0 4px 6px 0 rgba(50, 50, 93, 0.11);
            }
         }
         &--primary-custom {
            padding: 11.99px 24px;
            @media (max-width: 350px) {
               padding: 11.99px 15px;
               font-size: 13px;
            }
         }
         &--grad-custom {
            @media (max-width: 483px) {
               margin-bottom: 18px;
            }
         }
      }
   }
}
</style>

<style lang="scss">
.chart-desc {
   p {
      margin-bottom: 2rem !important;
   }
}
</style>
